import { createFileRoute, redirect } from "@tanstack/react-router";

// The per-farm livestock dashboard was consolidated into the scope-aware
// Livestock hub. Redirect this legacy URL onto the hub with the farm preselected
// via `?farm=`, which leaves the farm-intrinsic path entirely (no path↔param
// desync, so no redirect loop — see the farm-scope gotcha in the package
// CLAUDE.md). Mirrors grass-production/farms/$farmId/index.tsx.
export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/livestock/$establishmentId/",
)({
	staticData: { offline: "ready" },
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/app/org/$orgId/livestock",
			params: { orgId: params.orgId },
			search: { farm: params.establishmentId },
		});
	},
});
